"use strict";
exports.__esModule = true;
var angular = require("angular");
require('./issue-modal.component.css');
var COMPONENT_NAME = 'smartorg.r6.cmpts.issueModal';
var inav_utils_service_1 = require("../../components/utils/inav-utils.service");
var issue_list_1 = require("../../components/utils/issue-list/issue-list");
var IssueModalComponent = /** @class */ (function () {
    function IssueModalComponent($rootScope, $scope, $timeout) {
        this.headersData = [];
        this.selectedControls = [];
        this.issueCategoryList = ["CANVAS", "SWOT"];
        this.disableEdit = false;
        this.warningMsg = "";
        this.warningOpen = false;
        this.sliderOptionsImpact = {
            floor: 0,
            ceil: 9,
            showTicks: true,
            showTicksValues: true,
            disabled: false
        };
        this.sliderOptionsIgnorance = {
            floor: 0,
            ceil: 9,
            showTicks: true,
            showTicksValues: true
        };
        var ctrl = this;
        this.$scope = $scope;
        this.$rootScope = $rootScope;
        ctrl.showAlert = function (type, title, message) {
            $scope.$emit('workbench:alert', { type: type, title: title, message: message });
        };
        this.initListeners();
    }
    IssueModalComponent.prototype.initListeners = function () {
        var ctrl = this;
        ctrl.$rootScope.$on('issueModal', function (event, args) {
            ctrl.selectedIssue = args.selectedIssue;
            ctrl.origSelectedIssue = angular.copy(args.selectedIssue);
            ctrl.issueList = args.issueList;
            ctrl.node = args.node;
            ctrl.fteGlobal = args.fteGlobal;
            ctrl.disableEdit = (args.node.permissions == 'r');
            ctrl.modalData = args.modalData;
            ctrl.isDirty = false;
            ctrl.initUtility();
            ctrl.initImpactMapping();
        });
    };
    IssueModalComponent.prototype.initImpactMapping = function () {
        var ctrl = this;
        ctrl.modalData.distInputs.map(function (d) {
            var item = ctrl.headersData.find(function (n) { return n.name === d.actionName; });
            if (item) {
                item.count += 1;
            }
            else {
                ctrl.headersData.push({ name: d.actionName, count: 1 });
            }
            ctrl.selectedControls.push({ "key": d.key, "display": d.display });
        });
        ctrl.getIssueDiscoveryType();
    };
    IssueModalComponent.prototype.initCanvasConfig = function () {
        var ctrl = this;
        ctrl.canvasConfig = angular.fromJson(localStorage.getItem('nColCanvasConfig'));
        ctrl.title = ctrl.canvasConfig.Display;
        ctrl.issueConfig = ctrl.utilsService.getIssueConfigWithTitle(ctrl.canvasConfig.Config);
        // set n-col-canvas display name
        ctrl.issueCategoryList[0] = ctrl.title;
    };
    IssueModalComponent.prototype.initUtility = function () {
        var _a;
        var ctrl = this;
        ctrl.utilsService = new inav_utils_service_1.UtilsService(ctrl.issueList);
        var issueType = ctrl.utilsService.issueType;
        ctrl.initCanvasConfig();
        ctrl.canvasConfig.Config = ctrl.canvasConfig.Config.map(function (x) {
            return x = {
                TITLE: x.title ? x.title : x.type,
                NAME: x.type,
                COLOR: x.color
            };
        });
        ctrl.stickyTypeList = (_a = {},
            _a[ctrl.title] = ctrl.canvasConfig.Config,
            _a['SWOT'] = [issueType.STRENGTHS, issueType.WEAKNESSES, issueType.OPPORTUNITIES,
                issueType.THREATS],
            _a);
        ctrl.selectedCategory = (ctrl.stickyTypeList['SWOT'].findIndex(function (x) { return x.NAME == ctrl.selectedIssue.type; })) > -1 ? 'SWOT' : ctrl.title;
        ctrl.origSelectedCategory = angular.copy(ctrl.selectedCategory);
        /* if ('inavImpactType' in ctrl.node) {
            ctrl.isQualitative = ctrl.node['inavImpactType'] == 'Qualitative';
        } */
        ctrl.isQualitative = ctrl.modalData.isQualitative;
        ctrl.sliderOptionsImpact.disabled = !ctrl.isQualitative;
    };
    IssueModalComponent.prototype.resetBack = function () {
        var ctrl = this;
        ctrl.selectedIssue = angular.copy(ctrl.origSelectedIssue);
        ctrl.isDirty = false;
        ctrl.initUtility();
    };
    IssueModalComponent.prototype.radioExistAbility = function (key) {
        var ctrl = this;
        return ctrl.selectedIssue.abilityToLaunch.key == key;
    };
    IssueModalComponent.prototype.getIssueDiscoveryType = function () {
        var ctrl = this;
        // alert("The "+id +"is clicked Now: Impact: "+ctrl.selectedIssue.impact +" Ignorance:"+ctrl.selectedIssue.ignorance)
        var impactToBeUsed = ctrl.isQualitative ? ctrl.selectedIssue.impact : ctrl.selectedIssue.calcImpact;
        ctrl.selectedIssue.score = impactToBeUsed * ctrl.selectedIssue.ignorance;
        ctrl.selectedIssue.issueColor = this.utilsService.zoneColor[ctrl.getDiscoveryGrid(ctrl.selectedIssue.ignorance, impactToBeUsed).replace(/ /g, "")];
        ctrl.selectedIssue.issueType = ctrl.getDiscoveryGrid(ctrl.selectedIssue.ignorance, impactToBeUsed);
        ctrl.checkSave();
    };
    IssueModalComponent.prototype.onCatChange = function () {
        var ctrl = this;
        if (ctrl.selectedCategory == ctrl.origSelectedCategory) {
            ctrl.selectedIssue.type = ctrl.origSelectedIssue.type;
        }
        else {
            ctrl.selectedIssue.type = ctrl.stickyTypeList[ctrl.selectedCategory][0].NAME;
        }
        ctrl.checkSave();
    };
    IssueModalComponent.prototype.onLtChange = function (newOne, display) {
        var ctrl = this;
        var newData = {
            "key": newOne,
            "display": display,
            "reason": { "high": '', "low": '' }
        };
        if (newOne == 'pss') // potential showstopper
         {
            ctrl.selectedIssue.isPotentialShowStopper = !ctrl.selectedIssue.isPotentialShowStopper;
        }
        else {
            if (ctrl.modalData.inputTypeLt == 'radio') {
                if (ctrl.selectedIssue.impactMappingList != 'default' &&
                    ctrl.selectedIssue.impactMappingList[0]['Key'] == newOne) {
                    ctrl.selectedIssue.impactMappingList = "default";
                    ctrl.selectedIssue.calcImpact = 0;
                }
                else {
                    if (ctrl.selectedIssue.impactMappingList != 'default' &&
                        newData.key == ctrl.selectedIssue.impactMappingList[0].key) {
                        ctrl.selectedIssue.impactMappingList = 'default';
                        ctrl.selectedIssue.calcImpact = 0;
                    }
                    else {
                        // ctrl.issueDetails.impactMappingList = [newData];
                        if (ctrl.selectedIssue.impactMappingList == 'default') {
                            ctrl.selectedIssue.impactMappingList = [newData];
                        }
                        else {
                            ctrl.selectedIssue.impactMappingList[0].key = newData.key;
                            ctrl.selectedIssue.impactMappingList[0].display = newData.display;
                        }
                        ctrl.selectedIssue.calcImpact = this.getCalculatedImpact(display);
                    }
                }
            }
            else if (ctrl.modalData.inputTypeLt == 'checkbox') {
                if (!(ctrl.selectedIssue.impactMappingList && ctrl.selectedIssue.impactMappingList != 'default')) {
                    ctrl.selectedIssue.impactMappingList = [];
                }
                var existIndex = ctrl.selectedIssue.impactMappingList.findIndex(function (n) { return n.key === newOne; });
                if (existIndex > -1) { //exist
                    ctrl.selectedIssue.impactMappingList.splice(existIndex, 1);
                    if (ctrl.selectedIssue.impactMappingList.length == 0) {
                        ctrl.selectedIssue.impactMappingList = 'default';
                        ctrl.selectedIssue.calcImpact = 0;
                    }
                }
                else {
                    ctrl.selectedIssue.impactMappingList.push(newData);
                    ctrl.selectedIssue.calcImpact = this.getCalculatedImpactCheckbox(ctrl.selectedIssue.impactMappingList);
                }
            }
        }
        if (!ctrl.selectedIssue.isPotentialShowStopper) {
            ctrl.selectedIssue.abilityToLaunch.key = "default";
            ctrl.selectedIssue.calcImpact = 0;
            if (ctrl.selectedIssue.impactMappingList != 'default') {
                ctrl.selectedIssue.calcImpact = this.getCalculatedImpactCheckbox(ctrl.selectedIssue.impactMappingList);
            }
        }
        else {
            var calcImpactValues = { 'default': 0, 'hardSt': 8, 'mediumSt': 5, 'easySt': 2 };
            if (ctrl.selectedIssue.abilityToLaunch.key != 'default') {
                ctrl.selectedIssue.calcImpact = ctrl.selectedIssue.calcImpact > calcImpactValues[ctrl.selectedIssue.abilityToLaunch.key] ?
                    ctrl.selectedIssue.calcImpact : calcImpactValues[ctrl.selectedIssue.abilityToLaunch.key];
            }
        }
        ctrl.selectedIssue.updatedAt = ctrl.utilsService.updatedAt();
        ctrl.getIssueDiscoveryType();
    };
    IssueModalComponent.prototype.onStChange = function (key) {
        var ctrl = this;
        var calcImpactValues = { 'default': 0, 'hardSt': 8, 'mediumSt': 5, 'easySt': 2 };
        ctrl.selectedIssue.abilityToLaunch.key = ctrl.selectedIssue.abilityToLaunch.key == key ? 'default' : key;
        if (ctrl.selectedIssue.impactMappingList == 'default') {
            ctrl.selectedIssue.calcImpact = calcImpactValues[ctrl.selectedIssue.abilityToLaunch.key];
        }
        else {
            if (ctrl.modalData.inputTypeLt == 'radio') {
                ctrl.selectedIssue.calcImpact = this.getCalculatedImpact(ctrl.selectedIssue.impactMappingList[0]['display']);
            }
            else if (ctrl.modalData.inputTypeLt == 'checkbox') {
                ctrl.selectedIssue.calcImpact = this.getCalculatedImpactCheckbox(ctrl.selectedIssue.impactMappingList);
            }
            ctrl.selectedIssue.calcImpact = calcImpactValues[ctrl.selectedIssue.abilityToLaunch.key] > (ctrl.selectedIssue.calcImpact || 0) ?
                calcImpactValues[ctrl.selectedIssue.abilityToLaunch.key] : (ctrl.selectedIssue.calcImpact || 0);
        }
        ctrl.getIssueDiscoveryType();
    };
    IssueModalComponent.prototype.checkSave = function () {
        var ctrl = this;
        // ctrl.isDirty=ctrl.utilsService.checkSave(ctrl.selectedIssue, ctrl.origSelectedIssue);
    };
    IssueModalComponent.prototype.checkboxExist = function (stickyData, key) {
        var exist = false;
        try {
            // For potential showstopper case
            if (key == 'pss') {
                exist = stickyData.isPotentialShowStopper;
            }
            else {
                var indexGot = stickyData.impactMappingList.findIndex(function (n) { return n['key'] == key; });
                if (indexGot != -1) {
                    exist = true;
                }
            }
        }
        catch (e) {
        }
        return exist;
    };
    IssueModalComponent.prototype.radioExist = function (stickyData, key) {
        var exist = false;
        try {
            if (stickyData.impactMappingList != "default"
                && stickyData.impactMappingList.length > 0) {
                if (stickyData.impactMappingList[0].key == key) {
                    exist = true;
                }
            }
        }
        catch (e) { }
        return exist;
    };
    IssueModalComponent.prototype.getDiscoveryGrid = function (ignorance, impact) {
        return ignorance >= 5 && impact >= 5
            ? "DISCOVERY"
            : ignorance >= 5 && impact < 5
                ? "SPECIFY"
                : ignorance < 5 && impact >= 5
                    ? "NAVIGATE"
                    : "MANAGE";
    };
    IssueModalComponent.prototype.getCalculatedImpactCheckbox = function (rangeArr) {
        var ctrl = this;
        var scores = [];
        rangeArr.forEach(function (range) {
            var npvSwing = ctrl.getNpvSwing(range.display);
            var npvMax = ctrl.modalData.npvData[0].npvSwing; // Considering first as max always
            var finalScore = 0;
            finalScore = Math.round((npvSwing / npvMax) * 8.99 + 0.5);
            if (isNaN(finalScore)) {
                finalScore = 0;
            }
            scores.push(finalScore);
        });
        return rangeArr.length > 0 ? Math.max.apply(Math, scores) : null;
    };
    IssueModalComponent.prototype.getNpvSwing = function (display) {
        var ctrl = this;
        var item = ctrl.modalData.npvData.find(function (n) { return n.name === display; });
        return item.npvSwing;
    };
    IssueModalComponent.prototype.getCalculatedImpact = function (display) {
        var ctrl = this;
        var npvSwing = ctrl.getNpvSwing(display);
        var npvMax = ctrl.modalData.npvData[0].npvSwing; // Considering first as max always
        return Math.round((npvSwing / npvMax) * 8.99 + 0.5);
    };
    IssueModalComponent.prototype.setWarningDialog = function () {
        var _this = this;
        var ctrl = this;
        if (ctrl.issueList == issue_list_1.IssueListEnum.N_COL_CANVAS) {
            // From N-Column Canvas to SWOT
            ctrl.stickyTypeList.SWOT.map(function (i) {
                if (ctrl.selectedIssue.type == i.NAME && ctrl.selectedIssue.type != _this.utilsService.issueType.DEFAULT.NAME) {
                    ctrl.warningMsg = 'Issue will disappear from ' + ctrl.title + ' Board and appear on SWOT Board';
                }
            });
        }
        else if (ctrl.issueList == issue_list_1.IssueListEnum.SWOT) {
            // From SWOT to N-Column Canvas
            ctrl.stickyTypeList[ctrl.title].map(function (i) {
                if (ctrl.selectedIssue.type == i.NAME && ctrl.selectedIssue.type != _this.utilsService.issueType.DEFAULT.NAME) {
                    ctrl.warningMsg = 'Issue will disappear from SWOT Board and appear on ' + ctrl.title;
                }
            });
        }
        if (ctrl.warningMsg != "") {
            ctrl.warningOpen = true;
        }
        else {
            ctrl.saveIssue();
        }
    };
    IssueModalComponent.prototype.saveIssue = function () {
        var ctrl = this;
        var saveIssueEmitter = 'saveNColCanvas';
        switch (ctrl.issueList) {
            case issue_list_1.IssueListEnum.DFV:
                saveIssueEmitter = 'saveDFV';
                break;
            case issue_list_1.IssueListEnum.SWOT:
                saveIssueEmitter = 'saveSWOT';
                break;
            case issue_list_1.IssueListEnum.INPUT_SCREEN:
                saveIssueEmitter = 'saveInput';
                break;
            case issue_list_1.IssueListEnum.N_COL_CANVAS:
                saveIssueEmitter = 'saveNColCanvas';
                break;
        }
        ctrl.$scope.$emit(saveIssueEmitter, { 'selectedIssue': ctrl.selectedIssue });
        ctrl.clearSelection();
    };
    IssueModalComponent.prototype.clearSelection = function () {
        var ctrl = this;
        ctrl.headersData = [];
        ctrl.selectedControls = [];
        ctrl.modalData = null;
        ctrl.selectedIssue = null;
    };
    IssueModalComponent.prototype.closeWarningDialog = function (isSaveNColCanvas) {
        var ctrl = this;
        ctrl.warningOpen = false;
        ctrl.warningMsg = "";
        if (isSaveNColCanvas) {
            ctrl.saveIssue();
        }
    };
    return IssueModalComponent;
}());
angular.module(COMPONENT_NAME, []).component('issueModal', {
    template: require('./issue-modal.component.html'),
    controller: IssueModalComponent,
    bindings: {
        smartorg: '=',
        menu: '='
    }
});
module.exports = COMPONENT_NAME;
//# sourceMappingURL=issue-modal.component.js.map


// WEBPACK FOOTER //
// ./app/components/issue-modal/issue-modal.component.js